<div class="modal-header">
  <h3 class="modal-title">{{'create_workspace_modal_title' | translate}}</h3>
  <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" class="modal-close-btn" (click)="close()">
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <form [formGroup]="createWorkspaceForm" (ngSubmit)="createWorkspace()">
        <p class="big">{{'create_workspace_modal_description' | translate}}</p>
        <label class="form-label">{{'create_workspace_modal_name_label' | translate}}</label>
        <input class="form-control" formControlName="workspaceName" type="text">
        <button class="btn green-btn" style="margin-top: 30px" type="submit">{{'create_workspace_modal_finish_btn' | translate}}</button>
      </form>
    </div>
  </div>
</div>
